import { createSlice, createSelector } from '@reduxjs/toolkit';

const initialState = {
    watchList: [],
};

const watchListSlice = createSlice({
    name: 'watchList',
    initialState,
    reducers: {
        toggleWatchList: (state, action) => {
            const { mode, id, data } = action.payload;
            let watchListData = { ...data.movie_data, ...data.info };
            const existingIndex = state.watchList.findIndex(
                (item) => item.mode === mode && item.id === id
            );

            if (existingIndex !== -1) {
                state.watchList.splice(existingIndex, 1);
            } else {
                state.watchList.push({ mode, id, data: watchListData });
            }
        },
        clearWatchList: (state) => {
            state.watchList = [];
        },
    },
});

// Export actions
export const { toggleWatchList, clearWatchList } = watchListSlice.actions;

// Base selector to get all watch list items
export const selectWatchList = (state) => state.watchList.watchList || [];

// Selector to filter movies
export const selectWatchListMovies = createSelector(
    [selectWatchList],
    (watchList) => watchList.filter((item) => item.mode === 'movie')
);

// Selector to filter series
export const selectWatchListSeries = createSelector(
    [selectWatchList],
    (watchList) => watchList.filter((item) => item.mode === 'series')
);

// Memoized selector to check if an item is in the watch list
export const selectIsInWatchList = (mode, id) =>
    createSelector(
        [selectWatchList],
        (watchList) => watchList.some((item) => item.mode === mode && item.id === id)
    );

export default watchListSlice.reducer;
